<template>
    <CompassTooltip
        :content="getExtensionOptionLabel()"
        placement="top"
        :delay="{ show: 0, hide: 1 }"
        :disabled="disabled"
    >
        <CompassIconButton
            :icon="getExtensionOptionIcon()"
            size="small"
            :disabled="disabled && loadingAttachment"
            :active="activeStyle(option)"
            @click="selectFile"
        />
        <input
            ref="fileInput"
            type="file"
            style="display: none"
            multiple
            @change="handleFileChange"
        />
    </CompassTooltip>
</template>

<script>
import OptionsRichTextMixin from 'mixins/OptionsRichTextMixin';

export default {
    name: 'ImageRichText',
    mixins: [OptionsRichTextMixin],
    props: {
        attachmentEndpoint: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            loadingAttachment: false,
        };
    },
    methods: {
        getExtensionOptionLabel() {
            return this.$t.__(this.getExtensionOption(this.option).label);
        },
        getExtensionOptionIcon() {
            return this.getExtensionOption(this.option).icon;
        },
        // Select a file from the computer
        selectFile() {
            this.$refs.fileInput.click();
        },
        // Handle the file change (when a file is selected)
        async handleFileChange(event) {
            this.loadingAttachment = true;
            const files = event.target.files;

            for (const file of files) {
                const formData = new FormData();
                formData.append('file', file);
                const formattedFile = formData;
                let fileDetails = {};

                if (file) {
                    fileDetails = {
                        name: file.name,
                        size: file.size,
                        content_type: file.type,
                        content_id: file.name,
                        extension: '',
                        isFileLoaded: true,
                    };
                    await EventBus.$emit('loadingAttachments', fileDetails);
                }

                const endpoint =
                    this.attachmentEndpoint !== '' ? this.attachmentEndpoint : '/email/attachment';

                ApiClient.post(endpoint, {}, formattedFile)
                    .then((response) => {
                        if (response.data) {
                            const fileInfo = response.data;
                            const parsedFile = {
                                name: fileInfo.name,
                                size: fileInfo.size,
                                extension: fileInfo.extension,
                                content_id: fileInfo.content_id || fileInfo.id,
                                content_type: fileInfo.content_type,
                                content_disposition: 'attachment',
                                public_link: fileInfo.public_link,
                            };
                            EventBus.$emit('addAttachment', parsedFile);
                            this.loadingAttachment = true;
                        }
                    })
                    .catch((error) => {
                        const errorMessage = error.response.data.error.message;
                        const errorResponse = {
                            name: fileDetails.name,
                            size: fileDetails.size,
                            error_text: errorMessage,
                            error: true,
                            error_message: errorMessage,
                        };

                        if (typeof errorMessage === 'object') {
                            for (const message of Object.values(errorMessage)) {
                                errorResponse.error_text = message;
                                errorResponse.error_message = message;
                                EventBus.$emit('addAttachment', { ...errorResponse });
                            }
                        } else {
                            EventBus.$emit('addAttachment', { ...errorResponse });
                        }
                    })
                    .finally(() => {
                        this.$refs.fileInput.value = '';
                        this.loadingAttachment = false;
                    });
            }
        },
    },
};
</script>
